import {useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'

const useIsIOSMobile = () => {
  const location = useLocation()

  const [isIosMobile, setIsIosMobile] = useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const isMobileQueryParam = searchParams.get('ismobile')

    setIsIosMobile(isMobileQueryParam === 'ios')
  }, [location])

  return isIosMobile
}

export default useIsIOSMobile
